export enum EventEnum {
  Event = 'events'
}

export enum EventEnumApi {
  event = 'events/'
}
